import { Drawer } from '@/components/shared/Drawer'
import { assetPath } from '@/utils/assetPath'
import { Button } from '@/components/shared/atoms/Button'

const FEEDBACK_TYPES = ['Request new feature', 'Report a bug', 'Other']

export const FeedbackTypeBottomSheet = ({
    open,
    onClose,
    onSelect,
    selectedType,
    drawerPosition,
}: {
    drawerPosition?: 'bottom' | 'center' | undefined
    open: boolean
    onClose: () => void
    onSelect: (type: string) => void
    selectedType: string
}) => {
    return (
        <Drawer
            contentClassName="lg:w-1/6 lg:p-4"
            position={drawerPosition}
            triggerContent={null}
            open={open}
            onOpenChange={onClose}
        >
            <div className="mx-auto flex max-w-md flex-col gap-4 px-2 pb-4">
                <div className="flex flex-col">
                    {FEEDBACK_TYPES.map((type) => (
                        <div
                            key={type}
                            onClick={() => onSelect(type)}
                            className="border-black-6 flex items-center justify-between border-b py-4"
                        >
                            <p className="text-base font-medium">{type}</p>
                            {selectedType === type && (
                                <img
                                    src={assetPath('icons/check-outlined.svg')}
                                    alt="check"
                                    className="px-2"
                                />
                            )}
                        </div>
                    ))}
                </div>

                <Button variant="outline" onClick={onClose}>
                    Close
                </Button>
            </div>
        </Drawer>
    )
}
